export const getStyles = () => {
    const styles = {
        progress: {
            position: 'relative', 
            bottom: '30px', 
            height: '300px'
        }
    };
    return styles;
};